<template>
  <div
    class="lg:rounded-md min-w-full lg:shadow-md lg:border border-solid lg:border-gray-200 z-10 text-xs overflow-hidden whitespace-no-wrap"
  >
    <slot>
      <div class="bg-gray-100 lg:rounded-md">
        <a
          v-for="record in records"
          :key="record.id"
          :href="record.url"
          class="block p-3 lg:py-2 lg:px-4 border-t border-dashed border-gray-300 first:border-t-0 text-gray-600 hover:text-gray-800"
          :rel="record.rel"
          :target="record.target"
        >
          {{ record.label }}
        </a>
      </div>
    </slot>
  </div>
</template>
<script>
import { EscapeHandler } from '@ssdcode/cms-partials';

export default {
  mixins: [EscapeHandler],
  props: {
    records: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleEscape() {
      this.$emit('close');
    },
  },
};
</script>
